import React, {
	useEffect, useMemo, useState, useContext,
} from 'react';
import ReactDOM from 'react-dom';
import { SpotlightContext } from './spotlight-context';

interface SpotlightConnectorProps {
    desiredContainerId?: string;
    uniqueSpotlightId: string,
    children?: React.ReactNode;
	mediaId: number;
}

const SpotlightConnector: React.FC<SpotlightConnectorProps> = (
	{
		desiredContainerId,
		uniqueSpotlightId,
		children,
		mediaId,
	},
) => {
	const {
		getSpotlight,
		freeSpotlight,
		updateSpotlightPortal,
	} = useContext(SpotlightContext);
	const [container, setContainer] = useState<HTMLDivElement | HTMLElement |null>(null);
	// When getting the spotlight it's up to this component to give it a suitable id.
	// This will probably be coming from the media id coupled with the page number
	// to account for slides.
	const spotlightId = useMemo(() => getSpotlight(uniqueSpotlightId, mediaId), []);

	useEffect(
		() => () => {
			console.log('Unmounting spotlight connector', mediaId);
			
			freeSpotlight(spotlightId);
		},
		[],
	);

	useEffect(
		() => {
			if (desiredContainerId) {
				updateSpotlightPortal(spotlightId, desiredContainerId, mediaId);
			}
		},
		[desiredContainerId, spotlightId],
	);
	const findContainer = () => {
		const createdDiv = document.getElementById(spotlightId);
		if (createdDiv) {
			setContainer(createdDiv);
		} else {
			setTimeout(findContainer, 10);
		}
	};

	useEffect(
		() => {
			findContainer();
		},
		[spotlightId],
	);
	const theChildren = useMemo(() => (container && ReactDOM.createPortal(children, container as HTMLDivElement)), [container]);

	return (
        <>

	{ theChildren

	}</>);
};

export default SpotlightConnector;
